<template>
  <div class="row">
    <div class="col-auto">
      <button
        type="button"
        :disabled="!indexList"
        class="btn rounded-circle p-0 my-auto"
        :class="!indexList ? 'bg-gray-400' : 'bg-blue-500'"
        @click="setMinus"
      >
        <img :src="aws + '/less-white.svg'">
      </button>
    </div>
    <div class="col my-auto">
      <input
        :id="inputId"
        :value="display"
        type="text"
        readonly="true"
        class="form-control bg-white text-center"
      >
    </div>
    <div class="col-auto">
      <button
        type="button"
        :disabled="indexList === list.length - 1"
        :class="indexList === list.length - 1 ? 'bg-gray-400' : 'bg-blue-500'"
        class="btn rounded-circle p-0 my-auto"
        @click="setPlus"
      >
        <img :src="aws + '/plus-white.svg'">
      </button>
    </div>
  </div>
</template>
<script>
import input from '@/mixins/input-2';

export default {
  name: 'PlusMinusInput',
  mixins: [input],
  props: {
    list: {
      type: [Array, null],
      default: null,
    },
    format: {
      type: Function,
      default: (value) => value,
    },
  },
  data() {
    return {
      customList: [],
      indexList: 0,
    };
  },
  computed: {
    display() {
      const item = this.customList[this.indexList];
      if (item) {
        return this.format(item);
      }
      return null;
    },
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/svg`,
  },
  watch: {
    list: {
      deep: true,
      handler(value) {
        this.customList = value;
        this.indexList = this.list.findIndex(({ enabled }) => enabled);
      },
    },
  },
  mounted() {
    this.customList = this.list || [];
    this.indexList = this.list.findIndex(({ enabled }) => enabled);
  },
  methods: {
    setPlus() {
      this.indexList += 1;
      const newList = this.list.map((elem) => ({ ...elem, enabled: false }));
      Object.assign(newList[this.indexList], { enabled: true });
      this.setCustomModel(newList);
    },
    setMinus() {
      this.indexList -= 1;
      const newList = [...this.list].map((elem) => ({ ...elem, enabled: false }));
      newList[this.indexList].enabled = true;
      this.setCustomModel(newList);
    },
  },
};
</script>
<style scoped>
button {
  min-width: 56px;
  min-height: 56px;
  max-width: 56px;
  max-height: 56px;
  border: 0;
}
</style>
